import BarChartIcon from '../assets/bar-chart.svg';
import './ExternalSchoolMessage.css';

interface ExternalSchoolMessageProps {
  message: string;
}

const ExternalSchoolMessage = ({ message }: ExternalSchoolMessageProps) => {
  return (
    <div className="external-school-message">
      <img src={BarChartIcon} alt="bar chart" className="external-icon" />
      <p className="na-text">N/A</p>
      <p className="external-message">{message}</p>
    </div>
  );
};

export default ExternalSchoolMessage;
